import { useRef, useState } from 'react';
import Popover from '~/components/common/Popover';
import { CoreOfficeDataType } from '~/types/offices';
import { useTranslation } from 'react-i18next';
import SVGIcon from '~/components/ui/Icons/SVGIcon';
import mixpanelTrack from '~/hooks/useMixPanel';

type TProps = {
  office: CoreOfficeDataType;
};

const DiscountPopover = ({ office }: TProps) => {
  const { t } = useTranslation();
  const [popoverOpen, setPopoverOpen] = useState(false);
  const triggerRef = useRef(null);

  const discountLongTermPercent = Math.round(office.discountLongTermPercent || 0);
  const discountLastMinutePercent = Math.round(office.discountLastMinutePercent || 0);
  const totalDiscountAmount = Number(discountLastMinutePercent) + Number(discountLongTermPercent);

  return (
    <>
      <div className="d-flex">
        <div className="position-relative">
          <div
            className="d-flex align-items-center"
            role="button"
            onClick={() => {
              if (!popoverOpen) mixpanelTrack('E.discount_tooltip_click');
              setPopoverOpen(!popoverOpen);
            }}
            ref={triggerRef}
          >
            <SVGIcon
              iconType="discount"
              className="me-1"
              width="16"
              height="16"
              fill="#D61616"
            />
            <span className="text-2 -medium color-error-600 text-decoration-underline">
              {t('office.price.discount.discountApplicable', { amount: totalDiscountAmount })}
            </span>
          </div>
          <Popover
            triggerRef={triggerRef}
            arrowPosition="top-right"
            popoverPosition="bottom-right"
            isOpen={popoverOpen}
            onClose={() => setPopoverOpen(false)}
            width={504}
            title={t('office.price.discount.discountApplicable', { amount: totalDiscountAmount })}
          >
            {!!office.discountLastMinutePercent && (
              <div className={office.discountLongTermPercent ? 'mb-2' : ''}>
                <div className="d-flex justify-content-between">
                  <div className="text-nowrap text-1 -medium">{t('office.show.lastMinuteDiscount.title')}</div>
                  <div className="fo-display-5 -semibold">-{discountLastMinutePercent}%</div>
                </div>
                <div className="text-2 -regular color-grey-500 mt-2">
                  {t('office.show.lastMinuteDiscount.description', {
                    discountPercentage: discountLastMinutePercent,
                    amountOfDays: office.discountLastMinuteDays,
                  })}
                </div>
              </div>
            )}
            {!!office.discountLongTermPercent && (
              <div className={''}>
                <div className="d-flex justify-content-between">
                  <div className="text-nowrap text-1 -medium">{t('office.show.longTermDiscount.title')}</div>
                  <div className="fo-display-5 -semibold">-{discountLongTermPercent}%</div>
                </div>
                <div className="text-2 -regular color-grey-500 mt-2">
                  {t('office.show.longTermDiscount.description', {
                    discountPercentage: discountLongTermPercent,
                    amountOfMonths: office.discountLongTermMonths,
                  })}
                </div>
              </div>
            )}
          </Popover>
        </div>
      </div>
    </>
  );
};

export default DiscountPopover;
